import { render, staticRenderFns } from "./DirectorSalaryLatest.vue?vue&type=template&id=dcfd8b66"
import script from "./DirectorSalaryLatest.vue?vue&type=script&lang=js"
export * from "./DirectorSalaryLatest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports